import React, { useState } from 'react';
import { API_BASE_URL } from '../config/api';
import { localSandboxEnabled } from '../utils/localSandbox';

export default function LocalSandboxPanel() {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  const [error, setError] = useState('');
  if (!localSandboxEnabled) return null;
  const refresh = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/local/scenarios`);
      if (!response.ok) throw new Error('Local API is unavailable');
      setData(await response.json()); setError('');
    } catch (err) { setError(err.message); }
  };
  return <aside style={{ position: 'fixed', bottom: 12, right: 12, zIndex: 1100, maxWidth: 'calc(100vw - 24px)' }}>
    <button className="btn btn-warning" onClick={() => { setOpen(!open); refresh(); }}>Local test data / SMS inbox</button>
    {open && <div style={{ background: 'white', border: '2px solid #ffc107', padding: 16, width: 410, maxWidth: '100%', maxHeight: '65vh', overflow: 'auto' }}>
      <p><strong>Local sandbox — no real SMS or identity provider</strong></p>
      <p>Seed password: <code>LocalOnly123!</code>. Create more accounts with the normal signup form.</p>
      {data?.accounts.map(a => <p key={a.email}><code>{a.email}</code> — {a.description}</p>)}
      <p>Rental phones:</p>{data?.rentals.map(r => <p key={r.id}>{r.first_name}: <code>{r.phone_number}</code></p>)}
      <button className="btn btn-outline-primary" onClick={refresh}>Refresh SMS inbox</button>
      {data?.messages.map(m => <p key={m.id}><code>{m.phone}</code>: <strong>{m.code}</strong></p>)}
      {error && <p role="alert">{error}</p>}
    </div>}
  </aside>;
}
